<div class="static-page contact-us-page" [innerHTML]="pageContent" *ngIf="!loading; else loadingSplash"></div>

<ng-template #loadingSplash>
  <div *ngIf="loading" fxFlex="" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
